import "@vb/ui/tokens.css";
import "./app.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { App } from "./App.js";
import { ErrorBoundary } from "./ErrorBoundary.js";
import { captureUTM } from "./lib/utm.js";

// Capture marketing attribution from the entry URL before the app mounts.
// Wrapped defensively — a UTM/storage failure must never block app boot.
try {
  captureUTM();
} catch {
  // ignore — analytics is best-effort, not load-bearing
}

const root = document.getElementById("root");
if (!root) throw new Error("missing root element");
createRoot(root).render(
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
